import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.239 4.757q.001.007-.004.015L10.172 9.64a.75.75 0 0 1-.737.609h-6.87a.75.75 0 0 1-.737-.61L.765 4.773l-.003-.015a.75.75 0 0 1 1.3-.63L3.642 5.83l1.678-3.764V2.06a.75.75 0 0 1 1.362.005L8.36 5.83l1.579-1.701a.75.75 0 0 1 1.299.629z"
    }, null, -1)
  ])))
}
export default { render: render }